import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useEffect, useState, useMemo } from 'react';
import { searchCourseByTitle, clearCourseSearch as clear } from 'actions/search';
import { putData } from 'actions';
import { getCourse } from 'actions/courses';
import { toggleSelectedSection } from 'actions/sections';
import { getSchoolTypes } from 'actions/tenants';
import { useTranslate } from 'lib/translate';
import { useSelector, useDispatch } from 'react-redux';
import Modal from 'containers/Modals/Modal';
import { Spinner } from 'UI';
import { Search } from 'UI/Inputs';
import { Tabs, Tab, Button, Checkbox } from '@haldor/ui';

var SelectCourses = function SelectCourses(props) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      searching = _useState2[0],
      setSearching = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      submitting = _useState4[0],
      setSubmitting = _useState4[1];

  var _useState5 = useState([]),
      _useState6 = _slicedToArray(_useState5, 2),
      selected = _useState6[0],
      setSelected = _useState6[1];

  var _useState7 = useState(true),
      _useState8 = _slicedToArray(_useState7, 2),
      addOnGroup = _useState8[0],
      setAddOnGroup = _useState8[1];

  var _useState9 = useState('All'),
      _useState10 = _slicedToArray(_useState9, 2),
      schoolType = _useState10[0],
      setSchoolType = _useState10[1];

  var _useState11 = useState('All'),
      _useState12 = _slicedToArray(_useState11, 2),
      year = _useState12[0],
      setYear = _useState12[1];

  var _useState13 = useState(''),
      _useState14 = _slicedToArray(_useState13, 2),
      searchValue = _useState14[0],
      setSearchValue = _useState14[1];

  var sections = useSelector(function (state) {
    return state.sections.selected;
  });
  var group = useSelector(function (state) {
    return state.assignments.section;
  });
  var searchResultsData = useSelector(function (state) {
    return state.Courses.courseSearchResults;
  });
  var courseDetails = useSelector(function (state) {
    return state.Courses.courses;
  });
  var schoolTypes = useSelector(function (state) {
    return state.Tenant.schoolTypes;
  });
  var YEARS = ["All", 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  var translate = useTranslate();
  var dispatch = useDispatch();
  useEffect(function () {
    if (schoolTypes == null || schoolTypes.length == 0) {
      dispatch(getSchoolTypes());
    }
  }, []);
  var sectionCourses = useMemo(function () {
    if ((sections == null || sections.length == 0) && group == null) {
      return [];
    } else if ((sections == null || sections.length == 0) && group != null) {
      return group.courses;
    }

    var courses = [];
    sections.forEach(function (element) {
      element.courses.forEach(function (course) {
        if (props.skipCourses != null) {
          if (props.skipCourses.indexOf(course.id) > -1) {
            return null;
          }
        }

        courses.push(JSON.parse(JSON.stringify(course)));
      });
    });
    var removeDuplicate = courses.filter(function (item, index, self) {
      return self.findIndex(function (t) {
        return t.id === item.id;
      }) === index;
    });
    return removeDuplicate;
  }, [sections, props.skipCourses]);
  var searchResults = useMemo(function () {
    if (searchResultsData == null || searchResultsData.length == 0) {
      return [];
    }

    return JSON.parse(JSON.stringify(searchResultsData)).filter(function (course) {
      if (props.skipCourses == null) {
        return false;
      }

      return props.skipCourses.indexOf(course.id) == -1;
    }).filter(function (v, i, a) {
      return a.findIndex(function (v2) {
        return v2.id === v.id;
      }) === i;
    });
  }, [searchResultsData]);

  var onSubmit = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(event) {
      var values, missingDetails, groups;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              event.preventDefault();
              setSubmitting(true);
              values = selected;
              missingDetails = selected.filter(function (course) {
                return course.details.length == 0;
              });

              if (!(missingDetails.length > 0)) {
                _context3.next = 11;
                break;
              }

              _context3.next = 7;
              return Promise.all(missingDetails.map(function (course) {
                return new Promise( /*#__PURE__*/function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(resolve) {
                    var details;
                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.next = 2;
                            return dispatch(getCourse(course.id));

                          case 2:
                            details = courseDetails.find(function (c) {
                              return c.id == course.id;
                            });

                            if (details != null) {
                              values = values.map(function (course) {
                                return course.id == details.id ? details : course;
                              });
                            }

                            resolve();

                          case 5:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  return function (_x2) {
                    return _ref2.apply(this, arguments);
                  };
                }());
              }));

            case 7:
              if (!addOnGroup) {
                _context3.next = 11;
                break;
              }

              groups = JSON.parse(JSON.stringify(sections));
              _context3.next = 11;
              return Promise.all(groups.map(function (group) {
                return new Promise( /*#__PURE__*/function () {
                  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(resolve) {
                    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            dispatch(toggleSelectedSection(group));
                            missingDetails.forEach(function (course) {
                              var courseWithDetails = courseDetails.find(function (c) {
                                return c.id == course.id;
                              });
                              group.courses.push(courseWithDetails);
                            });
                            _context2.next = 4;
                            return dispatch(putData('sections', group));

                          case 4:
                            dispatch(toggleSelectedSection(group));
                            resolve();

                          case 6:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2);
                  }));

                  return function (_x3) {
                    return _ref3.apply(this, arguments);
                  };
                }());
              }));

            case 11:
              if (props.onSubmit != null) {
                props.onSubmit(values);
              }

            case 12:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function onSubmit(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var onSearch = function onSearch() {
    setSelected([]);

    if (searchValue == '' && schoolType == 'All' && year == 'All') {
      dispatch(clear());
      return;
    }

    setSearching(true);
    dispatch(searchCourseByTitle(searchValue == '' ? null : searchValue, schoolType == 'All' ? '' : schoolType, year == 'All' ? '' : year)).then(function () {
      setSearching(false);
    });
  };

  useEffect(function () {
    onSearch();
  }, [year, schoolType]);

  var renderCourse = function renderCourse(course, index) {
    var value = selected.find(function (s) {
      return s.id == course.id;
    }) != null;
    var schoolType = translate(course.typeOfSchooling);
    var courseTitle = "".concat(course.title, " - ").concat(course.year != null ? course.year : '', " ").concat(course.courseCode, " (").concat(schoolType, ")");
    return /*#__PURE__*/React.createElement("div", {
      className: "df aic",
      style: {
        marginBottom: '.55rem'
      },
      key: course.id
    }, /*#__PURE__*/React.createElement(Checkbox, {
      label: courseTitle,
      onChange: function onChange() {
        return toggleCourse(course);
      },
      value: value
    }));
  };

  var toggleCourse = function toggleCourse(course) {
    var found = selected.find(function (s) {
      return s.id == course.id;
    });

    if (found != null) {
      setSelected(selected.filter(function (s) {
        return s.id != course.id;
      }));
    } else {
      setSelected([].concat(_toConsumableArray(selected), [course]));
    }
  };

  var toggleAll = function toggleAll(checked) {
    if (checked) {
      var courses = [];
      sections.forEach(function (element) {
        element.courses.forEach(function (course) {
          return courses.push(course);
        });
      });
      setSelected([].concat(courses));
      return;
    }

    ;
    setSelected([]);
  };

  var selectedSchoolType = schoolTypes === null || schoolTypes === void 0 ? void 0 : schoolTypes.find(function (type) {
    return type.typeId == schoolType;
  });
  return /*#__PURE__*/React.createElement(Modal, {
    isOpen: true,
    type: "small news",
    onClose: props.onClose,
    overridePrompt: true
  }, /*#__PURE__*/React.createElement("div", {
    className: "form",
    style: {
      marginBottom: '2.5rem'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "title"
  }, translate('Curriculums')), /*#__PURE__*/React.createElement(Tabs, {
    onChange: function onChange() {
      return setSelected([]);
    }
  }, /*#__PURE__*/React.createElement(Tab, {
    title: translate('Group curriculums')
  }, sectionCourses.length > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Checkbox, {
    label: translate('All'),
    onChange: function onChange(value) {
      return toggleAll(value);
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      marginLeft: '2.25rem',
      marginTop: '.55rem'
    }
  }, sectionCourses.map(function (course, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: index
    }, renderCourse(course, index));
  }))) : /*#__PURE__*/React.createElement("p", null, translate('No curriculums added to the group')), /*#__PURE__*/React.createElement("div", {
    className: "df aic jcb",
    style: {
      marginTop: '1.55rem'
    }
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onSubmit,
    disabled: submitting || selected.length == 0
  }, submitting ? /*#__PURE__*/React.createElement(Spinner, null) : null, translate('Add')))), /*#__PURE__*/React.createElement(Tab, {
    title: translate('Search curriculum')
  }, /*#__PURE__*/React.createElement(Search, {
    onSubmit: onSearch,
    loading: searching,
    onChange: function onChange(value) {
      return setSearchValue(value);
    },
    allowEmpty: true
  }), schoolTypes != null && schoolTypes.length > 0 ? /*#__PURE__*/React.createElement("div", {
    className: "df",
    style: {
      marginTop: '1.5rem',
      marginBottom: '1rem'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: '47%',
      padding: '0px !important',
      marginRight: '1rem'
    }
  }, /*#__PURE__*/React.createElement("label", {
    style: {
      margin: 0
    }
  }, translate('Filter')), /*#__PURE__*/React.createElement("div", {
    className: "select",
    style: {
      marginTop: '.5rem'
    }
  }, /*#__PURE__*/React.createElement("select", {
    name: "schoolType",
    value: schoolType,
    onChange: function onChange(e) {
      return setSchoolType(e.target.value);
    }
  }, /*#__PURE__*/React.createElement("option", {
    value: "All"
  }, translate('All')), schoolTypes === null || schoolTypes === void 0 ? void 0 : schoolTypes.sort(function (a, b) {
    return translate(a.typeId).localeCompare(translate(b.typeId));
  }).map(function (schoolType, index) {
    return /*#__PURE__*/React.createElement("option", {
      key: index,
      value: schoolType.typeId
    }, translate(schoolType.typeId));
  })))), selectedSchoolType != null && selectedSchoolType.maxYear != null && selectedSchoolType.minYear != null ? /*#__PURE__*/React.createElement("div", {
    style: {
      padding: 0,
      width: 'auto',
      flex: 1,
      marginLeft: '2rem'
    }
  }, /*#__PURE__*/React.createElement("label", {
    style: {
      margin: 0
    }
  }, translate('course-year')), /*#__PURE__*/React.createElement("div", {
    className: "select",
    style: {
      marginTop: '8px'
    }
  }, /*#__PURE__*/React.createElement("select", {
    name: "year",
    value: year,
    onChange: function onChange(e) {
      return setYear(e.target.value);
    }
  }, YEARS.filter(function (year) {
    if (year == 'All') {
      return true;
    }

    return year >= (selectedSchoolType === null || selectedSchoolType === void 0 ? void 0 : selectedSchoolType.minYear) && year <= (selectedSchoolType === null || selectedSchoolType === void 0 ? void 0 : selectedSchoolType.maxYear);
  }).map(function (year, index) {
    return /*#__PURE__*/React.createElement("option", {
      key: index,
      value: year
    }, translate(year));
  })))) : null) : null, /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: '1rem'
    }
  }, searchResults != null && searchResults.length > 0 ? searchResults.map(renderCourse) : /*#__PURE__*/React.createElement("p", null, translate('No search result'))), /*#__PURE__*/React.createElement("div", {
    className: "df aic jcb",
    style: {
      marginTop: '1.55rem'
    }
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onSubmit,
    disabled: submitting || selected.length == 0
  }, submitting ? /*#__PURE__*/React.createElement(Spinner, null) : null, translate('Add')), /*#__PURE__*/React.createElement(Checkbox, {
    value: addOnGroup,
    onChange: setAddOnGroup,
    label: translate('Add curriculum to group')
  })))))));
};

export default SelectCourses;